import { apiFetch } from "../../Utils/ApiClient";

export const updateQuotesLife = (data) => {
    
  return async (dispatch) => {
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/life/quotes`, {
        method: 'PUT',
        body: JSON.stringify(data),
        headers: { 'Content-Type': 'application/json' },
      });
      return val;
    } catch (error) {
      console.error('Error in updateQuotesLife:', error);
      throw error;
    }
  };
};

export const uploadPolicyDocumentLife = (data,quoteId) => {
    
  return async (dispatch) => {
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/life/quotes/uploadPolicyPdfDocument/${quoteId}`, {
        method: 'PUT',
        body: data, 
      });
      return val;
    } catch (error) {
      console.error('Error in uploadPolicyDocumentLife:', error);
      throw error;
    }
  };
};